/**
 * auditoriaApi — consulta a auditoria append-only (M1, RF-ADM-02, RN-GLOBAL-003).
 * Rota admin. Envelope `{ data }` + `nextCursor`.
 *
 * CONTRATO CONGELADO (BINDING):
 *  - GET /auditoria → { data: EventoAuditoria[], nextCursor: string|null }
 *
 * Os eventos NÃO carregam dado pessoal de titular do documento — apenas
 * metadados de operação (tipo, usuário, ip, timestamp, recurso). Nada é logado
 * no cliente (RN-M11-001).
 */

import { ApiClient } from './apiClient';

export type TipoEvento =
  | 'login'
  | 'edicao'
  | 'exportacao'
  | 'download'
  | 'usuario_excluido'
  | 'mfa_redefinido';

/** Evento da auditoria (GET /auditoria). */
export interface EventoAuditoria {
  readonly id: string;
  readonly tipo: TipoEvento;
  readonly usuarioId: string;
  readonly ip: string;
  readonly timestamp: string;
  readonly recurso: string;
}

/** Filtros aceitos pela consulta de auditoria. */
export interface AuditoriaFiltro {
  readonly tipo?: TipoEvento;
  readonly usuario?: string;
  readonly dataInicio?: string;
  readonly dataFim?: string;
  readonly cursor?: string;
}

/** Página de auditoria (cursor-based). */
export interface ListaAuditoria {
  readonly data: readonly EventoAuditoria[];
  readonly nextCursor: string | null;
}

interface ListaEnvelope<T> {
  readonly data: readonly T[];
  readonly nextCursor: string | null;
}

export class AuditoriaApi {
  constructor(private readonly client: ApiClient) {}

  /** GET /auditoria — eventos de auditoria (admin). */
  async listar(filtro: AuditoriaFiltro = {}): Promise<ListaAuditoria> {
    const params = new URLSearchParams();
    if (filtro.tipo) params.set('tipo', filtro.tipo);
    if (filtro.usuario) params.set('usuario', filtro.usuario);
    if (filtro.dataInicio) params.set('dataInicio', filtro.dataInicio);
    if (filtro.dataFim) params.set('dataFim', filtro.dataFim);
    if (filtro.cursor) params.set('cursor', filtro.cursor);
    const qs = params.toString();
    const resp = await this.client.request<ListaEnvelope<EventoAuditoria>>(
      `/auditoria${qs ? `?${qs}` : ''}`,
    );
    return { data: resp.data, nextCursor: resp.nextCursor };
  }
}
